module.exports = __webpack_public_path__ + "static/media/emailYesterDayTwo.4f3cc703.png";